import { useState, useEffect, useRef } from "react"
import { useParams } from 'react-router-dom'

import { Typography } from "@material-ui/core"
import Grid from '@material-ui/core/Grid'
import AddIcon from '@material-ui/icons/Add'

import CheckBox from "@base/Inputs/CheckBox/CheckBox"
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import IconButton from '@material-ui/core/IconButton'
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import AuthorizedFunction from '@security/AuthorizedFunction';
import BuscaEscola from '@base/Inputs/BuscaEscola'
import PendenciaService from '@services/PendenciaService'

import Dialog from "@base/Dialog"
import Toast from '@base/Toast'
import TextField from '@base/Inputs/Text'
import SelectOption from '@base/Inputs/Select'
import ButtonPrimary from '@base/Button'
import Select from '@base/Inputs/Select'
import Arquivo from '@base/Inputs/File'
import { ButtonSave } from '@base/Button/ButtonForm'

import { ProcessoResolver } from "@helpers/ProcessoHelper"

import useStatusPendencia from "@hooks/enums/useStatusPendencia"
import useDocumentosPendencia from "@hooks/enums/useDocumentosPendencia"

export const TratarPendenciaDialog = (props) => {

	const buscarEscolaTf = useRef(null);

  const processo = ProcessoResolver(useParams().processo);
  const [uploading, setUploading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const listagemStatus = useStatusPendencia();
  const listagemDocumentos = useDocumentosPendencia();

  const [status, setStatus] = useState("");
  const [observacoes, setObservacoes] = useState("");
  const [listStatusHistorico, setListStatusHistorico] = useState([]);
  const [openHistoricoStatus, setOpenHistoricoStatus] = useState(true);

  const [escola, setEscola] = useState("");
  const [numeroObjetoPostal, setNumeroObjetoPostal] = useState("");
  const [dataCriacao, setDataCriacao] = useState("");
  const [usuarioCriacao, setUsuarioCriacao] = useState("");
  const [id, setId] = useState("");
  const [pendencia, setPendencia] = useState("");
  const [tipoPendencia, setTipoPendencia] = useState("");

  const [listDocumentos, setListDocumentos] = useState([]);
  const [openDocumentos, setOpenDocumentos] = useState(true);
  const [tipoDocumento, setTipoDocumento] = useState();

  const [numeroCartao, setNumeroCartao] = useState();
	const [novaEscola, setNovaEscola] = useState({});

  const [danoIrreversivel, setDanoIrreversivel] = useState("");

	const escolaEncontrada = (escola) => {
		setNovaEscola(escola);
	};

  const toastRef = useRef(null);

  const buttonsSubmit = () => {

    if(AuthorizedFunction(["__processo.usuario.administrador"])) {
      return (
        <>
          {buttonAnexarDocumentos()}
          <ButtonSave onClick={tratarPendencia} name="Salvar" />
        </>
      );
    }

    return (
      <>
        {!props.readonly && buttonAnexarDocumentos()}
        {!props.readonly && <ButtonSave onClick={tratarPendencia} name="Salvar" />}
      </>
    );
  }

  const tratarPendencia = () => {
    let obj = {
      danoIrreversivel : danoIrreversivel,
      escola: novaEscola ? novaEscola.id : null,
      status: status,
		  observacoes: observacoes
    };

    if (status !== "") {
      PendenciaService.atualizar(processo.id, id, obj).then(resultado => {
        toastRef.current.show("success", "Status da Pendência atualizado com sucesso.");
        props.handleSave();
        props.handleClose();
        limparFormulario();
      });
    }
  }

  const limparFormulario = ()  => {
      setStatus();
	    setEscola();
	    setId();
	    setPendencia();
	    setDataCriacao();
	    setListDocumentos([]);
	    setListStatusHistorico([]);
      setObservacoes();
      setNovaEscola();
      setDanoIrreversivel();
  }

  useEffect(() => {
    if (props.id) {
      PendenciaService.listarUm(processo.id, props.id).then(resposta => {

        const { id, ultimoStatus, escola, tipoPendencia, dataCriacao, historicoStatus, documentos,usuarioCriacao,numeroObjetoPostal,materialDanificadoIrreversivel } = resposta.data;
        setStatus(ultimoStatus.id);
        setEscola(escola && escola.nome);
        setNumeroObjetoPostal(numeroObjetoPostal);
        setId(id);
        setTipoPendencia(tipoPendencia.id);
        setPendencia(tipoPendencia.descricao);
        setDataCriacao(dataCriacao);
        setUsuarioCriacao(usuarioCriacao);
        setListDocumentos(documentos);
        setListStatusHistorico(historicoStatus);
        setDanoIrreversivel(materialDanificadoIrreversivel);
      });
    }
  }, [props.id, props.open, processo]);

  const buttonAnexarDocumentos = () =>
    <ButtonPrimary
      onClick={() => setOpenDialog(true)}
      name="Anexar Documento ao Tratamento"
      startIcon={<AddIcon />}
    />

  const anexar = (arquivo) => {
    setUploading(true);
    const config = { headers: { 'content-type': 'multipart/form-data' } };

    const file = new FormData();
    file.append('tipoDocumento', tipoDocumento);
    file.append('numeroCartao', tipoDocumento === "CARTAO_RESPOSTA" ? numeroCartao : null);
    file.append('arquivo', arquivo);

    PendenciaService.uploadDocumentoTratamento(processo.id, id, file, config)
      .then(resultado => {
        setListDocumentos([...resultado.data.documentos]);
        fecharModalUploadDocumento();
        toastRef.current.show("success", "Upload de arquivo realizado com sucesso.");
      }).catch(erro => {
        toastRef.current.show("error", "Não foi posível fazer upload do arquivo.");
      }).finally(() => {
        setUploading(false);
      });
  }

  const download = (documento) => {
    PendenciaService.downloadDocumentoTratamento(processo.id, id, documento)
      .then(resultado => {
        toastRef.current.show("success", "Seu arquivo está sendo preparado para download.");
				window.open(URL.createObjectURL(new Blob([resultado.data], { type: resultado.data.type })), '_blank');
      }).catch(erro => {
        toastRef.current.show("error", "Não foi posível fazer download do arquivo.");
      });
  }

  const buttonDownloadDocumento = (id) =>
    <IconButton size="small" component="div" onClick={() => download(id)} >
      <GetAppOutlinedIcon />
    </IconButton>

  const tituloModal = () => `Anexar Documento`;

  const fecharModalUploadDocumento = () => {
    setOpenDialog(false);
    setTipoDocumento();
  };

  const closeModalTratamento = (event, reason) => {
    if (reason === "backdropClick") {
      return false;
    }

    props.handleClose();
    limparFormulario();
  }

  const tableDocumentos = () => {
    if (listDocumentos.length > 0) {
      return (
        <Grid item sm={12} lg={12}>
          <Accordion expanded={openDocumentos} onChange={() => setOpenDocumentos(!openDocumentos)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
              <Typography variant="h6">Documentos Anexados</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><b>Tipo de Documento</b></TableCell>
                    <TableCell><b>Data de Upload</b></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listDocumentos.map((documento) =>
                    <TableRow key={documento.id} hover>
                      <TableCell>{documento.tipoDocumento.descricao} {documento.tipoDocumento.id === "CARTAO_RESPOSTA" && ` - ${documento.numeroCartao}`}</TableCell>
                      <TableCell>{documento.dataUpload}</TableCell>
                      <TableCell>{buttonDownloadDocumento(documento.id)}</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        </Grid>
      )
    }

    return null;
  }

  const tableHistoricoStatus = () => {
    if (listStatusHistorico.length > 0) {
      return (
        <Grid item sm={12} lg={12}>
          <Accordion expanded={openHistoricoStatus} onChange={() => setOpenHistoricoStatus(!openHistoricoStatus)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
              <Typography variant="h6">Histórico de Tratamento</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><b>Status</b></TableCell>
                    <TableCell><b>Data</b></TableCell>
                    <TableCell><b>Usuário</b></TableCell>
					          <TableCell><b>Detalhes</b></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listStatusHistorico.map((status, key) =>
                    <TableRow key={key} hover>
                      <TableCell>{status.status}</TableCell>
                      <TableCell>{status.data}</TableCell>
                      <TableCell>{status.usuario}</TableCell>
						          <TableCell>{status.observacoes ? status.observacoes : "--"}</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        </Grid>
      )
    }

    return null;
  }

  return (
    <>
      <Toast ref={toastRef} />
      <Dialog
        maxWidth={"md"}
        fullWidth={true}
        closeDialog={closeModalTratamento}
        openDialog={props.open}
        title="Tratar Pendência"
        actions={buttonsSubmit()}
      >

		<Grid container spacing={3}>
          {escola && <Grid item sm={8}>
            <TextField disabled label="Escola" value={escola} />
          </Grid> }

          {numeroObjetoPostal &&
          <Grid item sm={4}>
            <TextField disabled label="Objeto Postal" value={numeroObjetoPostal} />
          </Grid> }
          {!escola &&
          <Grid item sm={8}>
							<BuscaEscola
								inputRef={buscarEscolaTf}
								size={4}
								autoFocus
                manterinep
								ocultarsubtitulo
								label={"Escola - INEP"}
								processo={processo.id}
								aoencontrar={escolaEncontrada}
								aonaoencontrar={() => {}}
							/>
    </Grid>}

        </Grid>

        {!escola && novaEscola && novaEscola.nome  &&
					<Grid container >
						<Grid item sm={12}>
								<TextField
										label="Escola"
										value={novaEscola.nome}
										disabled={true}
									/>
						</Grid>
					</Grid>}

        <Grid container spacing={3}>
          <Grid item sm={5}>
            <TextField disabled label="Pendência" value={pendencia} />
          </Grid>
          <Grid item sm={3}>
            <TextField disabled label="Data Criação" value={dataCriacao} />
          </Grid>
          <Grid item sm={4}>
            <TextField disabled label="Usuário Criação" value={usuarioCriacao ? usuarioCriacao : "Não informado"} />
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item sm={6}>
            <SelectOption
              label='Status da Pendência'
              value={status}
              name='Status'
              onChange={(e) => setStatus(e.target.value)}
              options={listagemStatus.data}
            />
          </Grid>
			<Grid item sm={6}>
			<TextField 	inputProps={{ maxLength: 5000 }}  multiline label="Detalhes do ocorrido" onChange={(e) => setObservacoes(e.target.value)}  value={observacoes} />
          </Grid>
        </Grid>
          {tipoPendencia === 5 &&
        <Grid container spacing={3}>

          <Grid item lg={12}>
          <CheckBox
                label='Não é possível recuperar o material'
                checked={danoIrreversivel}
                name='danoIrreversivel'
                onChange={(e) => setDanoIrreversivel(e.target.checked)}
              />
          </Grid>

        </Grid>}

        <Grid container spacing={3}>
          <Grid item lg={12}>
            {tableHistoricoStatus()}
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item lg={12}>
            {tableDocumentos()}
          </Grid>
        </Grid>

        <Dialog
          maxWidth={"sm"}
          fullWidth={true}
          closeDialog={fecharModalUploadDocumento}
          openDialog={openDialog}
          title={tituloModal()}
        >
          <Grid container spacing={3}>
            <Grid item lg={12}>
              <Select
                label='Tipo de Documento'
                required
                value={tipoDocumento}
                name="tipoDocumento"
                onChange={(e) => setTipoDocumento(e.target.value)}
                options={listagemDocumentos.data}
              />
            </Grid>

            {tipoDocumento === "CARTAO_RESPOSTA" &&
              <Grid item lg={12}>
                <TextField
                  label='Número do Cartão'
                  required
                  value={numeroCartao}
                  name="numeroCartao"
                  onChange={(e) => setNumeroCartao(e.target.value)}
                />
              </Grid>
            }

            {tipoDocumento &&
              <Arquivo handleUpload={anexar} loading={uploading} />
            }
          </Grid>
        </Dialog>
      </Dialog>

    </>
  );
}

export default TratarPendenciaDialog;
